import { preloadSqlEditor } from "@repo/ui/components/sql-editor";
import { useRouterState } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { useEffect } from "react";

import { boardPage$ } from "~/pages/board/board.store";
import { ChatActions } from "./chat-actions";
import { ChatPanel } from "./chat-panel";
import { Content } from "./content";
import { AppSidebar } from "./sidebar";

export const App = ({ children }: PropsWithChildren) => {
  const isBoardRoute = useRouterState({
    select: (s) => s.location.pathname.startsWith("/boards/"),
  });

  useEffect(() => {
    if (!isBoardRoute) {
      boardPage$.selectedBlockId.set(null);
    }
  }, [isBoardRoute]);

  // Warm the Monaco runtime in the background once the authenticated shell is
  // mounted so the dataset SQL editor is ready before the user navigates to a
  // dataset, instead of paying the CDN load on first open. Deferred to idle so
  // it never competes with first paint.
  useEffect(() => {
    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(() => preloadSqlEditor());
      return () => window.cancelIdleCallback?.(id);
    }
    const id = window.setTimeout(preloadSqlEditor, 200);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <>
      <AppSidebar />
      <Content>{children}</Content>
      <ChatPanel />
      <ChatActions />
    </>
  );
};
